import ExtensionsManager from './src/manager.js';

export default { ExtensionsManager };
